var React = require('react');

function BaselinePlayCircleOutline24px (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z","key":1})]);
}

BaselinePlayCircleOutline24px.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = BaselinePlayCircleOutline24px;

BaselinePlayCircleOutline24px.default = BaselinePlayCircleOutline24px;
